import * as React from 'react';

interface StatWidgetProps {
    entity: string;
    tooltip: string;
    progress: number;
    total: number;
    percentageComplete: number;
    icon: string;
}

export class StatWidget extends React.Component<StatWidgetProps, any> {
    constructor(props: StatWidgetProps) {
        super(props)
    }

    render() {
        return (
            <div className="panel panel-default">
                <div className="panel-body">
                    <span data-toggle="tooltip" data-placement="top" title={this.props.tooltip}>
                        <div className="col-sm-3">
                            <i className={"text-primary fa fa-3x " + this.props.icon}></i>
                        </div>
                        <div className="col-sm-9">
                            {this.props.progress} / {this.props.total} {this.props.entity}
                            <div className="progress">
                                <div className="progress-bar" role="progressbar" style={{ width: this.props.percentageComplete + '%' }} aria-valuenow={this.props.percentageComplete} aria-valuemin={0} aria-valuemax={this.props.total}></div>
                            </div>
                        </div>
                    </span>
                </div>
            </div>
        );

    }
}
